import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "computerWithMeter",
    iconColor: "white",
    text: "Manage end-to-end lifecycle of \nnetwork function aligned to \nstandard industry architecture",
    listItemCustomStyle: { width: "400px" },
  },
  {
    icon: "autonomousManagement",
    iconColor: "white",
    text: "Automate day 0/1/2 \nconfigurations of network \nfunctions with template solutions",
    listItemCustomStyle: { width: "400px" },
  },
  {
    icon: "gearWithSchema",
    iconColor: "white",
    text: "Vendor-agnostic orchestration \nplatform supporting network \nslicing, multi-cloud, and large-\nscale edge deployments",
    listItemCustomStyle: { width: "400px" },
  },
];

export const DATA_BENEFITS_TCA_1 = {
  title: "Accelerate deployment and \nmonitoring",
  titleNumber: "1.",
  text: "Evolutionize deployment: leverage extreme network automation for effortless, zero-touch \ndeployment of next-gen networks, empowering operators with unprecedented efficiency.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage("ILO_303"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_301"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/TCA/TCA_Intro_02.jpg",
  demoButtons: [
    {
      label: "Network DESIGNER DEMO",
      onClick: () => {
        setPreviousPage("ILO_302");
        setCurrentPage("ILO_306");
      },
      endIcon: "arrow-right",
    },
    {
      label: "Network operation team DEMO",
      onClick: () => {
        setPreviousPage("ILO_302");
        setCurrentPage("ILO_312");
      },
      endIcon: "arrow-right",
    },
  ],
};
